import {
  Conversation,
  Message,
  MessageEmailRecipient,
} from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

const LINEBREAK = `<br /><br />`;

function listContactDetails(supportEmail: string, authors: User[]) {
  let authorString = `---------- Contact details ----------${LINEBREAK}`;
  if (!authors) {
    return null;
  }
  const authorsArray = Object.values(authors);
  if (!Array.isArray(authorsArray)) {
    return null;
  }

  const contacts = authorsArray.filter((author) => author.type === 'contact');
  contacts.push({ email: supportEmail } as User);
  contacts.forEach((author: User) => {
    const name = author.name || '';
    const email = author.email || '';
    authorString += `${name} ${email}${LINEBREAK}`;
  });
  return authorString;
}

function listCcBccDetails(messages: Message[]) {
  return [
    { label: 'CC', selector: ({ cc_list_v2 }: Message) => cc_list_v2 },
    { label: 'BCC', selector: ({ bcc_list_v2 }: Message) => bcc_list_v2 },
  ].reduce((acc, { label, selector }) => {
    const emails = messages
      .reduce<MessageEmailRecipient[]>(
        (recipients, message) => [...recipients, ...(selector(message) ?? [])],
        [],
      )
      .map((recipient) => recipient.email);

    return emails.length
      ? `${acc}---------- ${label} details ----------${LINEBREAK}${emails.join(', ')}${LINEBREAK}`
      : acc;
  }, '');
}

/** The contact and CC/BCC details that head a forwarded transcript. */
export function getTranscriptLead(
  conversation: Conversation,
  authors: User[],
  messages: Message[],
): string {
  const supportEmail =
    conversation.direction === 'inbound'
      ? (conversation.attributes?.to_email as string)
      : (conversation.attributes?.from_email as string);
  const listContactLead = listContactDetails(supportEmail, authors);
  const customerLead = listContactLead
    ? `${listContactLead}${listCcBccDetails(messages)}`
    : '';

  return `${LINEBREAK}${LINEBREAK}${customerLead}${LINEBREAK}---------- Transcript message ---------${LINEBREAK}`;
}
